<div class="f f-gap-10" :class="{ 'o-50': !enabled }"><div class="fc-g1">{{ text }}</div><div class="t ital normal" v-if="!enabled">Hidden</div></div>